import { Component, OnInit, Inject, ViewChild, ElementRef  } from '@angular/core';
import { DlgTrabajandoComponent } from '../dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../dlg-error/dlg-error.component';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import {Location} from '@angular/common';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort} from '@angular/material/sort'
import { MatTableDataSource} from '@angular/material/table'
import {MatDialogRef} from '@angular/material/dialog';
import { funciones } from '../../../app/funciones';
import { DlgAvisoComponent } from '../dlg-aviso/dlg-aviso.component';

@Component({
  selector: 'app-dlg-registro-cel-emisor',
  templateUrl: './dlg-registro-cel-emisor.component.html',
  styleUrls: ['./dlg-registro-cel-emisor.component.css']
})
export class DlgRegistroCelEmisorComponent implements OnInit {

  lblTitRegEmisor="";

  constructor(
    public dialog: MatDialog,
    private httpClient: HttpClient,
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgRegistroCelEmisorComponent>

  ) { }

  ngOnInit(): void {

  }
  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena});
  }

  solicitaqr(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, { 
      width: '600px',
      disableClose:true

    });
    dlgTrabajando.componentInstance.titulo="";
    dlgTrabajando.componentInstance.texto="Buscando el QR de inicialización del emisor";

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('idConexion', this.storage.get("idConexion"));
    urlSearchParams.append('tokenPushNotificaciones', this.storage.get("tokenPushNotificaciones"));
    
    let parametros = urlSearchParams.toString()

    this.httpClient.post(environment.servidorHttp+'Whatsapp/solicitarQR?'+parametros,null
      ,{
        headers:{
          "Authorization":'Bearer ' + this.storage.get("token"),
        }
      })
      .subscribe(data => {
        this.cerrarDialogo(dlgTrabajando);
        if (data['resultado']['msgError']['valorDevuelto'] == "01") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error 01 al soliciar QR";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
        } else if (data['resultado']['msgError']['valorDevuelto'] == "10") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error 10 al soliciar QR";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.router.navigate(['/']);
        } else {
          let dlgAviso = this.dialog.open(DlgAvisoComponent, {
            width: '600px',
            disableClose: true
          });
          dlgAviso.componentInstance.titulo = "Aviso del sistema";
          dlgAviso.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.cerrar('bien');
        }
      },
        (error: HttpErrorResponse) => {
          this.cerrarDialogo(dlgTrabajando);
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          if (error.status.toString() == "401") {
            dlgError.componentInstance.titulo = "Error 401 al soliciar QR";
            dlgError.componentInstance.texto = "Su sesión ha finalizado";
            this.router.navigate(['/']);
          } else {
            dlgError.componentInstance.titulo = "Error desconocido al soliciar QR";
            dlgError.componentInstance.texto = error.message + " (" + error.status + ")";
          }
        }
      );
  }




}
